export default __webpack_public_path__ + "static/media/Group 8150.a5f5950c.png";